<template>
  <div v-if="news" class="news__grid">
    <NewsroomNewsEntry
      v-for="newsEntry in news.data.stories"
      :key="newsEntry.uuid"
      class="news__entry"
      :story="newsEntry"
    />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  blok: {
    n_of_news?: number
  }
}

const props = defineProps<Props>()
const config = useRuntimeConfig()
const storyblokApi = useStoryblokApi()
const news = ref<any>(null)

news.value = await storyblokApi.get('cdn/stories', {
  version: config.public.storyblokApiVersion as 'draft' | 'published',
  starts_with: 'newsroom/in-the-news',
  per_page: props.blok.n_of_news || 3,
  filter_query: {
    component: {
      in: 'newsroom-news-entry',
    },
  },
})
</script>

<style lang="scss" scoped>
.news {
  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 22px;

    @media (min-width: $breakpoint-md) {
      grid-template-columns: 1fr 1fr;
      column-gap: 22px;
      row-gap: 48px;
    }

    @media (min-width: $breakpoint-lg) {
      grid-template-columns: repeat(3, 1fr);
      column-gap: 22px;
      row-gap: 56px;
    }
  }
}
</style>
